module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoEB.eaafc46.ttf";